var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.49 0 0 0.49 12.29 11.79)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 19 6.39)",
    id: "id_101"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-43, -30.39)",
    d: "M 44.485 31.5 A 2.489 2.489 0 0 0 44 27.211 V 23.79 l -2 0.85 v 2.571 a 2.489 2.489 0 0 0 -0.485 4.29 a 2.488 2.488 0 0 0 -1.015 2 V 36 a 1 1 0 0 0 1 1 h 3 a 1 1 0 0 0 1 -1 V 33.5 A 2.488 2.488 0 0 0 44.485 31.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 9.45)",
    id: "id_102"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -33.45)",
    d: "M 39 25.91 v 7.4 a 4.961 4.961 0 0 1 -2.4 4.28 a 24.984 24.984 0 0 1 -25.2 0 A 4.961 4.961 0 0 1 9 33.31 v -7.4 L 21.27 31.1 a 7.05 7.05 0 0 0 5.46 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -6)",
    id: "id_103"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -18)",
    d: "M 46.036 15.237 l -20.088 -8.5 a 5.029 5.029 0 0 0 -3.9 0 l -20.088 8.5 a 3 3 0 0 0 0 5.526 l 20.088 8.5 a 5.024 5.024 0 0 0 3.9 0 l 20.088 -8.5 a 3 3 0 0 0 0 -5.526 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.2a5d6fc017b1385fb7dd5a4856bff234.svg";
export { ForwardRef as ReactComponent };